import { useQuery, gql } from '@apollo/client'
import { useRouter } from 'next/router'

import { Link } from 'src/lib/router'

const RESOLVE_BOARD_UUID = gql`
  query ResolveBoard($legacyEid: String!) {
    resolveBoardByLegacyEid(legacyEid: $legacyEid) {
      id
    }
  }
`

const LegacyEidHelp = () => {
  const { id } = useRouter().query

  const { data, error, loading } = useQuery(RESOLVE_BOARD_UUID, {
    variables: { legacyEid: id }
  })

  if (loading) {
    return <div> loading ... </div>
  }

  if (error) {
    return <h3>Community Not Found</h3>
  }

  const board = data.resolveBoardByLegacyEid
  const u = new URL(window.location.href)

  const newPath = `/community/${board.id}`
  u.pathname = newPath
  const urlStr = u.toString()

  return (
    <>
      <div className="my-2">Invalid URL</div>
      <p>
        The page you are attempting to view has moved to a new URL, please
        update your bookmarks to use the following link:
      </p>
      <div className="my-2">
        <Link className="break-all" href={newPath}>
          {urlStr}
        </Link>
      </div>
    </>
  )
}

export default LegacyEidHelp
